import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isProjectArchived,
  isProjectInactive,
} from '../../common/helpers/projectStatusesUtils';

import {
  getOpenedProjectStatus,
  getProjectLoading,
  loadProjectThunk,
} from '../project/projectSlice';

const EnableForProjectState = ({ projectId, children }) => {
  const dispatch = useDispatch();
  const isProjectLoading = useSelector(getProjectLoading);
  const projectStatus = useSelector(getOpenedProjectStatus);

  const isJestTesting = process.env.JEST_WORKER_ID !== undefined;

  useEffect(() => {
    let isMounted = true;
    if (!isJestTesting && !isProjectLoading && !projectStatus && isMounted) {
      dispatch(loadProjectThunk(projectId));
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, isProjectLoading, isJestTesting, projectId, projectStatus]);

  return children({
    isProjectDisabled: projectStatus
      ? isProjectArchived(projectStatus) || isProjectInactive(projectStatus)
      : false,
  });
};

EnableForProjectState.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default EnableForProjectState;
